<template>
    <div class="d-flex justify-content-end col-12">
        <slot></slot>
        <button type="button" class="btn btn-secondary btn-sm me-2" @click="cancel" :disabled="cancelDisabled"><i class="d-inline" :class="cancelIcon"></i><span class="d-inline">&nbsp;{{ cancelText }}</span></button>
        <button type="button" class="btn btn-secondary btn-sm" @click="submit" :disabled="submitDisabled"><i class="d-inline" :class="submitIcon"></i><span class="d-inline">&nbsp;{{ submitText }}</span></button>
    </div>
</template>

<script>
export default {
    props: {
        cancelText: {
            type: String,
            default: 'Cancel'
        },

        submitText: {
            type: String,
            default: 'Submit'
        },

        cancelIcon: {
            type: String,
            default: 'fa-solid fa-ban'
        },

        submitIcon: {
            type: String,
            default: 'fa-solid fa-check'
        },

        cancelDisabled: {
            type: Boolean,
            default: false
        },

        submitDisabled: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        cancel: function() {
            this.$emit('cancel');
        },

        submit: function() {
            this.$emit('submit');
        }
    }
}
</script>